import { Scenarios } from '@jfs/network'

const getDmtAvailableLimitApi = {
  default: [
    {
      url: /productLimit\/getCustomerLimit/,
      method: 'POST',
      response: {
        yearlyLimit: 299892.0,
        yearlyCount: 1797,
        monthlyCount: 150,
        thirtydaysAmtLimit: 25000.0,
        dailyLimit: 25000.0,
        thirtydaysCountLimit: 100,
        monthlyLimit: 25000.0,
        dailyCount: 150,
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /productLimit\/getCustomerLimit/,
      method: 'POST',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '30013', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getDmtAvailableLimitApi }
